import post from './post';
import runBody from './runBody';
import configuration from '../configuration';
import { testConfig } from '../func';

const postManualRun = async (client, { trains, wells, aggregates }) => {
  const config = configuration();
  testConfig(config);
  const path = config.restPath;
  const project = config.project;
  const messageBody = {
    purpose: 'manual',
    ...runBody({ trains, wells, aggregates, config }),
    project
  };
  return post(path, client, JSON.parse(JSON.stringify(messageBody)));
};
export default postManualRun;